import { Flex } from '@chakra-ui/react'

import { useCustomFormViewer } from '../../../contexts/CustomFormViewerManager/Provider'
import CustomFormViewerQuestion from '../../../components/CustomFormViewerQuestion'

export default function CATComunicacaoDeAcidenteDeTrabalho() {
  const { questions, formMethods } = useCustomFormViewer()
  const { watch } = formMethods

  if (!questions) return null

  const titleForQuestion = Object.fromEntries(questions.map((q) => [q.title, q.slug]))

  const tipoDeOcorrencia = watch ? watch(`form_answers.${titleForQuestion['Tipo de Ocorrência']}`) : undefined

  const acidenteDeTrajeto = watch ? watch(`form_answers.${titleForQuestion['Acidente de trajeto']}`) : undefined

  return (
    <Flex bg="transparent" flexDir="column" gap={2} borderTop="1px solid" borderColor="primary">
      {questions.map((question, index) => {
        // tipoDeOcorrencia
        if (
          question.title == 'Data do diagnóstico' ||
          question.title == 'Local da ocorrência' ||
          question.title == 'Horário do acidente' ||
          question.title == 'Houve afastamento' ||
          question.title == 'Descrição do caso' ||
          question.title == 'Profissional que fez o diagnóstico' ||
          question.title == 'CRM ou Registro Profissional'
        ) {
          if (tipoDeOcorrencia == 'Acidente Típico' || tipoDeOcorrencia == 'Doença Ocupacional') {
            return (
              <CustomFormViewerQuestion
                key={question.id}
                question={question}
                index={index}
                questionsLength={questions?.length}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        // acidenteDeTrajeto
        if (question.title == 'Meio de locomoção' || question.title == 'Percuso' || question.title == 'Houve B.O') {
          if (acidenteDeTrajeto == 'Sim') {
            return (
              <CustomFormViewerQuestion
                key={question.id}
                question={question}
                index={index}
                questionsLength={questions?.length}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        return (
          <CustomFormViewerQuestion
            key={index}
            index={index}
            questionsLength={questions.length}
            question={question}
            disabled={false}
          />
        )
      })}
    </Flex>
  )
}
